import { useEffect, useState } from "react";
import axios from "axios";

const API_BASE = "http://dietdubacherla.in/diet_backend";

const sections = [
  { id: "students", label: "Student Teachers" },
  { id: "teachers", label: "In-Service Teachers" },
  { id: "notifications", label: "Notifications" },
  { id: "press", label: "Press Notes" },
];

export default function Downloads() {
  const [open, setOpen] = useState("students");
  const [files, setFiles] = useState([]);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    fetchDownloads();
  }, []);

  const fetchDownloads = () => {
    setLoading(true);

    axios
      .get(`${API_BASE}/get_downloads.php`)
      .then((res) => {
        setFiles(Array.isArray(res.data) ? res.data : []);
      })
      .catch((err) => {
        console.log(err);
        setFiles([]);
      })
      .finally(() => setLoading(false));
  };

  const normalize = (val) => {
    if (!val) return "";

    const map = {
      faculty: "teachers",
      "in-service": "teachers",
      student: "students",
    };

    const value = val.toString().trim().toLowerCase();
    return map[value] || value;
  };

  const getFilesByCategory = (category) =>
    files.filter((file) => normalize(file.category) === normalize(category));

  const getTypeLabel = (file) => {
    if (file.source_type === "link") return "LINK";
    if (file.source_type === "text") return "TEXT";
    const extension = file.file_name?.split(".").pop() || file.file_url?.split(".").pop() || "FILE";
    return extension.toUpperCase().slice(0, 5);
  };

  return (
    <div style={pageStyle}>
      <div style={headerStyle}>
        <div>
          <p style={eyebrowStyle}>DIET Resources</p>
          <h1 style={titleStyle}>Downloads</h1>
        </div>
        <button onClick={fetchDownloads} style={refreshButtonStyle}>
          Refresh
        </button>
      </div>

      <div style={containerStyle}>
        {sections.map((section) => {
          const sectionFiles = getFilesByCategory(section.id);
          const isOpen = open === section.id;

          return (
            <div key={section.id} style={sectionStyle}>
              <button
                style={{
                  ...sectionButton,
                  ...(isOpen ? sectionButtonActive : {}),
                }}
                onClick={() => setOpen(isOpen ? "" : section.id)}
              >
                <span>{section.label}</span>
                <span>{isOpen ? "Hide" : "View"}</span>
              </button>

              {isOpen && (
                <div style={contentStyle}>
                  {loading && <p style={emptyStyle}>Loading downloads...</p>}

                  {!loading &&
                    sectionFiles.map((file) => (
                      file.source_type === "text" ? (
                      <div
                        key={file.id || file.file_url}
                        style={linkStyle}
                      >
                        <span style={fileIconStyle}>{getTypeLabel(file)}</span>
                        <span>
                          <strong>{file.title || "Untitled Content"}</strong>
                          <small style={descriptionStyle}>{file.content_text}</small>
                        </span>
                      </div>
                      ) : (
                      <a
                        key={file.id || file.file_url}
                        href={file.file_url}
                        target="_blank"
                        rel="noreferrer"
                        style={linkStyle}
                      >
                        <span style={fileIconStyle}>{getTypeLabel(file)}</span>
                        <span>
                          <strong>{file.title || "Untitled Resource"}</strong>
                          {file.content_text && <small style={descriptionStyle}>{file.content_text}</small>}
                        </span>
                      </a>
                      )
                    ))}

                  {!loading && sectionFiles.length === 0 && (
                    <p style={emptyStyle}>No downloads uploaded in this category yet.</p>
                  )}
                </div>
              )}
            </div>
          );
        })}
      </div>
    </div>
  );
}

const pageStyle = {
  minHeight: "100vh",
  background: "#f3f4f6",
  padding: "28px",
  boxSizing: "border-box",
  fontFamily: "Inter, Arial, sans-serif",
};

const headerStyle = {
  maxWidth: "900px",
  margin: "0 auto 18px",
  display: "flex",
  alignItems: "center",
  justifyContent: "space-between",
  gap: "14px",
};

const eyebrowStyle = {
  margin: "0 0 6px",
  color: "#991b1b",
  fontSize: "12px",
  fontWeight: "800",
  textTransform: "uppercase",
};

const titleStyle = {
  margin: 0,
  color: "#111827",
  fontSize: "30px",
};

const refreshButtonStyle = {
  background: "#111827",
  color: "white",
  border: "none",
  padding: "10px 14px",
  borderRadius: "8px",
  cursor: "pointer",
  fontWeight: "800",
};

const containerStyle = {
  maxWidth: "900px",
  margin: "0 auto",
  display: "grid",
  gap: "12px",
};

const sectionStyle = {
  background: "white",
  border: "1px solid #e5e7eb",
  borderRadius: "8px",
  overflow: "hidden",
  boxShadow: "0 1px 2px rgba(15,23,42,0.05)",
};

const sectionButton = {
  width: "100%",
  display: "flex",
  alignItems: "center",
  justifyContent: "space-between",
  gap: "12px",
  textAlign: "left",
  padding: "16px",
  fontSize: "16px",
  fontWeight: "800",
  background: "white",
  color: "#111827",
  border: "none",
  cursor: "pointer",
};

const sectionButtonActive = {
  background: "#7f1d1d",
  color: "white",
};

const contentStyle = {
  padding: "14px 16px 16px",
  borderTop: "1px solid #e5e7eb",
  display: "grid",
  gap: "10px",
};

const linkStyle = {
  display: "flex",
  alignItems: "center",
  gap: "10px",
  padding: "12px",
  textDecoration: "none",
  color: "#374151",
  fontWeight: "700",
  background: "#f9fafb",
  border: "1px solid #e5e7eb",
  borderRadius: "8px",
};

const descriptionStyle = {
  display: "block",
  marginTop: "4px",
  color: "#6b7280",
  fontWeight: "600",
  lineHeight: 1.4,
};

const fileIconStyle = {
  flex: "0 0 auto",
  background: "#fee2e2",
  color: "#991b1b",
  borderRadius: "6px",
  padding: "5px 7px",
  fontSize: "11px",
  fontWeight: "900",
};

const emptyStyle = {
  margin: 0,
  padding: "14px",
  color: "#6b7280",
  background: "#f9fafb",
  border: "1px dashed #d1d5db",
  borderRadius: "8px",
  fontWeight: "700",
};
